import React from 'react';
import { FormField } from '../../components/FormField';
import { FormRow } from '../../components/FormRow';
import { LocationSelector } from '../../../../ui/LocationSelector';
import { useClientFormContext } from '../../contexts/ClientFormContext';

export const PersonalInfo: React.FC = () => {
  const { formData, handleInputChange } = useClientFormContext();

  return (
    <div className="space-y-4">
      <FormRow>
        <FormField label="Civilité">
          <select
            name="civility"
            value={formData.civility}
            onChange={handleInputChange}
            className="w-full"
          >
            <option value="">Sélectionner</option>
            <option value="M.">M.</option>
            <option value="Mme">Mme</option>
            <option value="Mlle">Mlle</option>
          </select>
        </FormField>

        <FormField label="Nom">
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            placeholder="Nom"
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField label="Prénom">
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            placeholder="Prénom"
          />
        </FormField>

        <FormField label="Téléphone">
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            placeholder="+213 XX XX XX XX XX"
          />
        </FormField>
      </FormRow>

      <FormField label="Email">
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="email@exemple.com"
        />
      </FormField>

      <FormField label="Adresse">
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleInputChange}
          placeholder="Adresse complète"
        />
      </FormField>

      <LocationSelector
        wilayaName="wilaya"
        wilayaValue={formData.wilaya}
        communeName="city"
        communeValue={formData.city}
        onWilayaChange={handleInputChange}
        onCommuneChange={handleInputChange}
      />

      <FormField label="Niveau d'intérêt">
        <select
          name="interestLevel"
          value={formData.interestLevel}
          onChange={handleInputChange}
          className="w-full"
        >
          <option value="interested">Intéressé</option>
          <option value="very-interested">Très intéressé</option>
          <option value="to-contact">À recontacter</option>
        </select>
      </FormField>

      <FormField label="Notes">
        <textarea
          name="notes"
          value={formData.notes}
          onChange={handleInputChange}
          rows={4}
          placeholder="Notes et commentaires sur le client..."
          className="w-full"
        />
      </FormField>
    </div>
  );
};